import React from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';

const QuickSearch = props => {
    const { query, result, showResult, isLoading, showAll, noHit, onSearch, selectedItem, searchUrl } = props
    var searchInput

    React.useEffect(() => {
        if(searchInput) {
            searchInput.focus();
        }
    }, [searchInput])

    const clearInput = () => {
        onSearch("")
        searchInput.focus()
    }

    return <>
        <div className="quick-search" role="search">
            <div className="field-wrapper">
                <div className="input-wrapper input-wrapper--has-icons">
                    <i className="icon icon-search start"></i>
                    <input placeholder={translate('general.search')} autoComplete="off" 
                        value={decodeURIComponent(query)} 
                        onChange={e => onSearch(encodeURIComponent(e.target.value))}
                        ref={input => searchInput = input} />
                    {!isLoading && <i className="icon icon-cross icon-small end" onClick={clearInput}></i>}
                    {isLoading && <i className="icon icon-update icon-spin-reverse end"></i>}
                </div>
            </div>
        </div>
        {showResult && <QuickSearchResult result={result} showAll={showAll} noHit={noHit} selectedItem={selectedItem} searchUrl={searchUrl}/>}
    </>
}

export default QuickSearch;